import { getTranslatedMoment } from '../translations';
import { IntlShape } from 'react-intl';

const moment = getTranslatedMoment();

const MAX_DATE = new Date(2147483647000);
const MIN_DATE = new Date(0);
export const DATE_SORT_DIRECTION = {
  NULL_PAST: 'past',
  NULL_FUTURE: 'future',
};

/**
 * Gets the date range for contact list queries
 * Returns last 4 weeks to current week in GGGG-WW format
 */
export const getContactListDateRange = (): {
  startWeek: string;
  endWeek: string;
} => {
  return {
    startWeek: moment().subtract(4, 'w').format('GGGG-WW'),
    endWeek: moment().format('GGGG-WW'),
  };
};

const parseDateWithDirection = (
  date: Date,
  direction: string
): moment.Moment => {
  if (date !== undefined && moment(date).isValid()) {
    return moment(date);
  }
  if (direction === DATE_SORT_DIRECTION.NULL_FUTURE) {
    return moment(MAX_DATE);
  }
  if (direction === DATE_SORT_DIRECTION.NULL_PAST) {
    return moment(MIN_DATE);
  }
  return moment();
};
export const dateComprarator = (
  a: Date,
  b: Date,
  direction: string
): number => {
  const dateA = parseDateWithDirection(a, direction);
  const dateB = parseDateWithDirection(b, direction);
  return dateA.diff(dateB);
};

export const daysInThePast = (targetDate: Date): string => {
  const now = moment.utc();
  const diff = moment.utc(targetDate).diff(now, 'days');
  return moment.duration(diff, 'd').humanize(true, { d: 999 });
};

interface WeeklyDates {
  start: moment.Moment;
  end: moment.Moment;
}

export const pastWeekDates = (): WeeklyDates => {
  const currentMoment = moment();
  const prevWeekMoment = currentMoment.clone().subtract(1, 'weeks');
  const prevPrevWeekMoment = currentMoment.clone().subtract(2, 'weeks');

  //We want to start our week on a monday to be alligned with Amazon Weeks
  const start = prevPrevWeekMoment.clone().startOf('week').add(1, 'day');
  const end = prevWeekMoment.clone().endOf('week');

  return { start, end };
};

export const formatMomentDates = (date: moment.Moment): string => {
  return date.format('YYYY-MM-DD');
};

export const formatForDisplay = (date: moment.Moment): Date => {
  return date.toDate();
};

export const formatWeeklyDateRange = (intl: IntlShape): string => {
  const { start, end } = pastWeekDates();
  // Start of most recently completed week for display
  const displayStart = end.clone().startOf('week');
  const displayEnd = end;

  const formattedStartDate = intl.formatDate(formatForDisplay(displayStart), {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const formattedEndDate = intl.formatDate(formatForDisplay(displayEnd), {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return `${formattedStartDate} - ${formattedEndDate}`;
};
